import type { ReactNode } from "react";
import InfoTooltip from "./InfoTooltip";

interface SectionProps {
  title: string;
  tooltip?: ReactNode;
  children: ReactNode;
  className?: string;
  description?: string | null;
}

export default function Section({
  title,
  tooltip,
  children,
  className = "",
  description = null,
}: SectionProps) {
  return (
    <div className={`mb-5 p-4 border border-gray-300 rounded bg-[#fcf8ef83] ${className}`}>
      <h2 className="text-2xl font-semibold mb-2">
        {title}
        {tooltip && <InfoTooltip>{tooltip}</InfoTooltip>}
      </h2>
      {description && (
        <p className="text-sm mx-4 md:mx-36 mb-2 mt-2">{description}</p>
      )}
      {children}
    </div>
  );
}
